import { useMutation } from "@connectrpc/connect-query";
import { ReservationService } from "@viajero/proto/guest/v1";

/**
 * ReservationService.CreateCheckoutSession を connect-query mutation でラップするフック。
 *
 * 「決済に進む」押下時に、予約内容 (再決済では予約 ID) と認証済み予約者情報を渡して呼び出す。
 * Backend は予約を作成し、TableCheck 空席確認を経て Stripe Checkout Session を発行して決済ページ URL と
 * 予約 ID を返す。SPA は返却された checkout_url へリダイレクトする (§6.5。JPTP_CANSEI-1678)。
 */
export function useCreateCheckoutSession() {
  return useMutation(ReservationService.method.createCheckoutSession);
}
